<template>
	<!-- muted is bound twice, deliberately — see the note in the script below.
		 vue/no-duplicate-attributes only sees two same-named bindings, not the
		 property/attribute split, so it is silenced for this one element. -->
	<!-- eslint-disable vue/no-duplicate-attributes -->
	<video ref="videoRef"
		   :muted.prop="muted"
		   :muted.attr="muted || null"
		   :poster="posterImage"
		   :disableremoteplayback="disableCastIcon || null"
		   :class="{ 'disable-cast-icon': disableCastIcon }">
		<!-- eslint-enable vue/no-duplicate-attributes -->

		<template v-for="video in data.video_files"
				  :key="video.directus_files_id.id">

			<source :src="`${config.public.mediaBase}${video.directus_files_id.id}-${video.directus_files_id.modified_on}`"
					:type="video.directus_files_id.type">
		</template>

		Your browser does not support HTML5 video.
	</video>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object,
		required: true
	},
	disableCastIcon: {
		type: Boolean,
		default: true
	},
	// Declared rather than left to fall through, so a video meant to carry sound simply
	// doesn't pass it. SingleVideo relies on starting muted and unmuting on click, which
	// still works — the live property overrides the attribute.
	//
	// In the template it is bound twice, and the two halves aren't interchangeable.
	// HTMLMediaElement.muted is one of the few IDL properties that doesn't reflect to
	// its content attribute (defaultMuted is the reflecting one), so binding it once
	// emits no `muted` attribute at all — unlike loop/autoplay/playsinline, which
	// reflect for free. Blink only honours a parser-set muted attribute, so Chrome
	// needs `.prop` (the live property); `.attr` writes the attribute the HTML spec and
	// Safari's autoplay docs call for. `|| null` matters: it's a boolean attribute, so
	// a literal false would still read as present.
	//
	// Use the compile-time modifiers, not a v-bind object of '.muted' / '^muted' keys:
	// those prefixes are interpreted by the client runtime's patchProp only, and the
	// SSR renderer serialises them verbatim — server-rendered videos (MultipleVideos,
	// Iconlist, RelatedCases' icon) end up with literal `.muted` / `^muted` attributes
	// and audible sound. The modifiers compile correctly on both paths.
	muted: {
		type: Boolean,
		default: false
	}
})

const config = useRuntimeConfig()

const posterImage = computed(() => props.data?.poster ? `${config.public.mediaBase}${props.data.poster.id}?width=300&height=300&quality=50` : null)


</script>

<style lang="scss" scoped>
video {
	width: 100%;
	height: auto;
}

// .disable-cast-icon::-internal-media-controls-overlay-cast-button {
// 	display: none;
// }</style>
